import Task from "../task/task"
import {ProjectItemOrigin} from "./@type"

// at the moment used for ProjectTask only
// idea to use it in future for other things - maybe project documents, attachments, etc...
export class ProjectItem {
    private task            : Task

    private _projectId       : ID
    public origin          : ProjectItemOrigin // how we added this item ...
    public sortPosition    : number // for now required

    constructor(data: any, task: Task) {
        this.task           = task

        this._projectId     = data.projectId
        this.origin         = data.origin
        this.sortPosition   = data.sortPosition
    }

    get projectId(): ID {
        return this._projectId
    }

    set projectId(value: ID) {
        this._projectId = value
        this.task.resetProjectsMap()
    }

    toJSON() {
        return {
            projectId       : this._projectId,
            origin          : this.origin,
            sortPosition    : this.sortPosition,
        }
    }
}